// © 2024–2026 Jos Jozef Sytze van der Werf — Alle rechten voorbehouden.
export const ROUTES = {
  // Public
  LOGIN:            '/login',
  ONBOARDING:       '/onboarding',
  NEXT_OF_KIN_ENTRY:'/toegang',

  // Protected - primary
  DASHBOARD:        '/',
  INTAKE:           '/intake',

  // Wizard steps accessible as standalone pages
  PARTNER:          '/partner',
  FINANCIAL:        '/financial',

  // Wishes
  WISHES:           '/wishes',
  WISHES_MEDICAL:   '/wishes/medical',
  WISHES_FUNERAL:        '/wishes/funeral',
  WISHES_FUNERAL_COSTS:  '/wishes/funeral-costs',
  WISHES_FAREWELL:  '/wishes/farewell',

  // Modules
  TRUSTED_PERSON:   '/trusted-person',
  ACCESS_KEY:       '/trusted-person/key',
  MESSAGES:         '/messages',
  DOCUMENTS:        '/documents',
  MUNICIPALITY:     '/municipality',
  AI_GUIDE:         '/ai-guide',
  VEHICLES:         '/vehicles',
  BUSINESS:         '/business',

  // Notarieel
  NOTARIAL:         '/notarial',

  // Kennisomgeving (geïntegreerd - geen apart kenniscentrum)
  LEVENSLIJN:       '/levenslijn',
  EUTHANASIE_INFO:  '/levenslijn/euthanasie',

  // System
  CONTROL_CENTER:   '/control-center',
  SETTINGS:         '/settings',

  // Legal
  PRIVACY:          '/privacy',
  TERMS:            '/voorwaarden',

  // Demo
  DEMO_PREVIEW:     '/demo-preview',

  // Next of kin
  NEXT_OF_KIN:      '/nabestaanden',
} as const

export type AppRoute = typeof ROUTES[keyof typeof ROUTES]

// Wizard route (added v5)
export const WIZARD_ROUTE = '/wizard'

// Dossiers (new v15)
export const DOSSIER_NOTARIS     = '/dossier/notaris'
export const DOSSIER_UITVAART    = '/dossier/uitvaart'
export const DOSSIER_NABESTAANDEN = '/dossier/nabestaanden'
export const DOSSIER_OVERVIEW     = '/dossiers'
export const HOME_ROUTE          = '/home'

